/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_TitleInputs */

const en_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI Tools Configuration`)
};

const fr_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration des outils CLI`)
};

const de_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI-Tools-Konfiguration`)
};

const it_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione degli strumenti CLI`)
};

const ru_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка инструментов командной строки`)
};

const es_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de herramientas CLI`)
};

const zh_cn2_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI 工具配置`)
};

const ja_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLIツールの設定`)
};

const hi_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI टूल्स कॉन्फ़िगरेशन`)
};

const pt_pt2_options_cli_title = /** @type {(inputs: Options_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração de ferramentas de linha de comando`)
};

/**
* | output |
* | --- |
* | "CLI Tools Configuration" |
*
* @param {Options_Cli_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_title = /** @type {((inputs?: Options_Cli_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_title(inputs)
	if (locale === "de") return de_options_cli_title(inputs)
	if (locale === "it") return it_options_cli_title(inputs)
	if (locale === "ru") return ru_options_cli_title(inputs)
	if (locale === "es") return es_options_cli_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_title(inputs)
	if (locale === "ja") return ja_options_cli_title(inputs)
	if (locale === "hi") return hi_options_cli_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_title(inputs)
	return en_options_cli_title(inputs)
});